import { useParams } from 'react-router-dom';
import { createVideoUrl } from '../utils/console';
import { Loader } from '../components/loader';

export const VideoLinkRedirect = ({ modulePath }: { modulePath: string }) => {
  const { customerId } = useParams();
  window.location.replace(createVideoUrl(modulePath, customerId));
  return <Loader />;
};
